<template>
  <div class="h-[380px] grid w-[380px] grid-cols-[60px_1fr] gap-2 select-none">
    <div class="relative">
      <div ref="productImagesEl" id="product-images"
        class="grid flex-col items-start justify-center gap-2  overflow-y-auto max-h-[380px] auto-rows-min py-[25px]">
        <template v-for="(image, imageIndex) in props.imagesUrl" :key="imageIndex">
          <a @click="selectedImageIndex = imageIndex" class="group cursor-pointer">
            <img
              class="h-[50px] w-[50px] border object-contain group-hover:rounded-md group-hover:border-4 group-hover:border-red-300"
              :class="{
                ['rounded-md border-4 border-red-400']: imageIndex == selectedImageIndex
              }" :src="image.thumb.src" />
          </a>
        </template>
      </div>
      <button @click="y -= 35" v-if="!arrivedState.top"
        class="absolute top-0 left-0 w-full flex justify-center backdrop-blur-sm">
        <IconArrowTop></IconArrowTop>
      </button>
      <button @click="() => {
        y += 35;
      }" v-if="!arrivedState.bottom" class="absolute bottom-0 left-0 w-full flex justify-center backdrop-blur-sm">
        <IconArrowBottom></IconArrowBottom>
      </button>
    </div>
    <div @click.stop="showImage" tabindex="0" class="relative flex justify-center overflow-hidden cursor-zoom-in">
      <img class="max-h-full w-full object-contain" :src="selectedImage.preview.src" alt="Cover image" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed, ref, useTemplateRef } from 'vue'
import { type ImgProduct } from '@/types/book_item'
import productImageNotFound from '@/assets/product_image_not_found.webp?url'
import { getWithHost } from '@/utils/utils'
import IconArrowTop from '@/components/icons/IconArrowTop.vue';
import IconArrowBottom from '@/components/icons/IconArrowBottom.vue'
import { useScroll } from '@vueuse/core';

const props = defineProps<{
  imagesUrl?: ImgProduct[]
}>()

const emit = defineEmits<{
  (e: 'event:imageClicked', index: number): void
}>()

const selectedImageIndex = ref(0)

const pIEl = useTemplateRef('productImagesEl')
const { arrivedState, y } = useScroll(pIEl, { behavior: 'smooth' })

const selectedImage = computed((): ImgProduct => {
  if (!props.imagesUrl) {
    return {
      thumb: {
        height: 0,
        width: 0,
        src: '',
      },
      preview: {
        height: 0,
        width: 0,
        src: '',
      }
    } as ImgProduct
  }
  if (!(props.imagesUrl[selectedImageIndex.value] ?? false)) {
    return {
      preview: {
        height: 257,
        width: 257,
        src: getWithHost(productImageNotFound)
      },
      thumb: {
        height: 257,
        width: 257,
        src: getWithHost(productImageNotFound)
      },
      full: {
        height: 257,
        width: 257,
        src: getWithHost(productImageNotFound)
      }
    }
  }
  return props.imagesUrl[selectedImageIndex.value]
})

const showImage = () => {
  emit('event:imageClicked', selectedImageIndex.value)
}

</script>
<style lang="sass">
#product-images::-webkit-scrollbar
  display: none

#product-images
  -ms-overflow-style: none  /* IE and Edge */
  scrollbar-width: none  /* Firefox */
</style>